import { GetAllNotificationsInDto, GetAllNotificationsOutDto } from '../../../types/notification.dto'

export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS'
export const GET_ALL_NOTIFICATIONS_SUCCESS = 'GET_ALL_NOTIFICATIONS_SUCCESS'
export const GET_ALL_NOTIFICATIONS_ERROR = 'GET_ALL_NOTIFICATIONS_ERROR'
export const RESET_GET_ALL_NOTIFICATIONS = 'RESET_GET_ALL_NOTIFICATIONS'

export interface GetAllNotifications {
  type: typeof GET_ALL_NOTIFICATIONS
  payload: GetAllNotificationsOutDto
}

export interface GetAllNotificationsSuccess {
  type: typeof GET_ALL_NOTIFICATIONS_SUCCESS
  payload: GetAllNotificationsInDto
}

export interface GetAllNotificationsError {
  type: typeof GET_ALL_NOTIFICATIONS_ERROR
  payload: string | boolean
}

export interface ResetGetAllNotifications {
  type: typeof RESET_GET_ALL_NOTIFICATIONS
  payload: null
}

export interface State {
  data: GetAllNotificationsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetAllNotifications | GetAllNotificationsSuccess | GetAllNotificationsError | ResetGetAllNotifications
